import { RandomGenerator } from "../../test-utils";
var BrandBuilder = /** @class */ (function () {
    function BrandBuilder() {
        this.brand = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            default: false,
            name: 'My Test Brand',
            enabled: false,
            primaryLocale: 'en',
            logoUrl: 'bob',
            creationDate: Date.now(),
            lastUpdateDate: Date.now(),
            settings: {
                helpCenter: {
                    enabled: false,
                    helpCenterV2Enabled: false,
                    ticketsPageEnabled: false,
                    enabledLocales: ['en'],
                    contentScopes: {},
                    snippets: {},
                    design: {
                        template: {
                            key: '',
                        },
                        colors: {
                            color1: '',
                            color2: '',
                            headerFooterColor: 10
                        },
                        logo: {
                            faviconUrl: '',
                            imageUrl: '',
                            targetUrl: ''
                        },
                        images: {
                            desktopBackgroundUrl: '',
                            mobileBackgroundUrl: '',
                            socialSharingUrl: ''
                        }
                    },
                    authentication: {
                        method: { mode: 0 },
                        restrictions: {
                            allowedDomains: [],
                            mode: 0
                        },
                        visibility: 0,
                        enableGuestTickets: true,
                        enableHeaderLogin: true
                    },
                    domain: {
                        name: RandomGenerator.randomName(),
                        mappingMethod: 10
                    },
                    domainConnected: false
                },
                defaultHostName: '',
            }
        };
    }
    BrandBuilder.prototype.withId = function (id) {
        this.brand.id = id;
        return this;
    };
    BrandBuilder.prototype.withDefault = function (isDefault) {
        this.brand.default = isDefault;
        return this;
    };
    BrandBuilder.prototype.withName = function (name) {
        this.brand.name = name;
        return this;
    };
    BrandBuilder.prototype.withEnabled = function (enabled) {
        this.brand.enabled = enabled;
        return this;
    };
    BrandBuilder.prototype.withCreationDate = function (creationDate) {
        this.brand.creationDate = creationDate;
        return this;
    };
    BrandBuilder.prototype.withLastUpdateDataDate = function (lastUpdateDate) {
        this.brand.lastUpdateDate = lastUpdateDate;
        return this;
    };
    BrandBuilder.prototype.withPrimaryLocale = function (primaryLocale) {
        this.brand.primaryLocale = primaryLocale;
        return this;
    };
    BrandBuilder.prototype.withLogoUrl = function (logoUrl) {
        this.brand.logoUrl = logoUrl;
        return this;
    };
    BrandBuilder.prototype.withHelpcenterSettings = function (helpCenterSettings) {
        this.brand.settings.helpCenter = helpCenterSettings;
        return this;
    };
    BrandBuilder.prototype.withDomainName = function (name) {
        this.brand.settings.helpCenter.domain.name = name;
        return this;
    };
    BrandBuilder.prototype.withHcEnabled = function (enabled) {
        this.brand.settings.helpCenter.enabled = enabled;
        return this;
    };
    BrandBuilder.prototype.withHcTicketingEnabled = function (enabled) {
        this.brand.settings.helpCenter.ticketsPageEnabled = enabled;
        return this;
    };
    BrandBuilder.prototype.withDefaultHostName = function (name) {
        this.brand.settings.defaultHostName = name;
        return this;
    };
    BrandBuilder.prototype.build = function () {
        return this.brand;
    };
    return BrandBuilder;
}());
export { BrandBuilder };
//# sourceMappingURL=builders.js.map